export enum ItemType {
  RichContent = 'rich-content',
  WidgetVideo = 'widget-video',
  WidgetAudio = 'widget-audio',
  Chart = 'chart',
  Area = 'area',
  Group = 'group',
  Image = 'image',
  Pin = 'pin',
  Svg = 'svg',
  Text = 'text',
  Activity = 'activity',
  Arrow = 'arrow',
  ContainerBox = 'containerBox',
  BaseWidget = 'base-widget',
}
